import ReactDOM from "react-dom";
import React, { PureComponent } from "react";
import { SurveyContext } from '../surveycontext';
import * as FormikControls from '../../libs/Formik';

class QuestionItems extends PureComponent {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    state = {
        selectedItem: null,
        error: null
    }

    submit = () => {
        const { items } = this.props;
        if (items && this.state.selectedItem == null) {
            this.setState({ 'error': 'error' });

            return;
        }

        if (items) {
            this.context.submitAnswer(this.state.selectedItem);
        }


        this.setState({ 'selectedItem': null, 'error': null });


    }

    handleChange = (e, value) => {
        const { items } = this.props;
        this.setState({
            'selectedItem': items.filter((item) => {
                return item.id == value;
            })[0]
        });
    }


    render() {
        const { items } = this.props;
        const { selectedItem, error } = this.state;
        const buttonText = (this.context.isLast ? 'Voltooien' : 'Volgende');
        const className = `inline field ${error}`;

        if (!items) {
            return (
                <button type="button" onClick={this.submit}>Voltooien</button>
            )
        }
        return (
            items &&
            <React.Fragment>
                <div className='questionitems'>
                    <ul>
                        {
                            items.map(function (item, index) {
                                const { name, text } = item;
                                let label = `${name}: ${text}`;
                                return (
                                    <li className={className} key={item.id}>
                                        <FormikControls.Radio
                                            name='Item'
                                            label={label}
                                            value={item.id}
                                            required
                                            id={`item_${index}`}
                                            checked={selectedItem != null && item.id == selectedItem.id}
                                            onChange={this.handleChange}
                                        />
                                    </li>);
                            }, this)
                        }
                    </ul>

                </div>
                <div className='ui inline field'>
                    <button className='ui button primary' type="button" onClick={this.submit}>{buttonText}</button>
                </div>
            </React.Fragment>
        );
    }
}

QuestionItems.contextType = SurveyContext;
export default QuestionItems;